import { render, staticRenderFns } from "./ModifyNoticeOrderMayang.vue?vue&type=template&id=57fc921c&scoped=true&"
import script from "./ModifyNoticeOrderMayang.vue?vue&type=script&lang=js&"
export * from "./ModifyNoticeOrderMayang.vue?vue&type=script&lang=js&"
import style0 from "./ModifyNoticeOrderMayang.vue?vue&type=style&index=0&id=57fc921c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fc921c",
  null
  
)

export default component.exports